import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';

export function Disclaimer() {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <div className="content-wrapper--medium">
        <div className="mb-4 flex items-center justify-between">
          <Link to="/" className="btn-text inline-block">
            ← {t('privacy.backHome')}
          </Link>
          <LanguageSwitcher />
        </div>

        <h1 className="page-title">{t('disclaimer.title')}</h1>

        <div className="card space-y-6">
          <section>
            <h2 className="section-heading--large">
              {t('disclaimer.noGuaranteeTitle')}
            </h2>
            <p className="text-gray-700">{t('disclaimer.noGuaranteeDesc')}</p>
          </section>

          <section>
            <h2 className="section-heading--large">
              {t('disclaimer.aiLimitationsTitle')}
            </h2>
            <p className="text-gray-700">{t('disclaimer.aiLimitationsDesc')}</p>
          </section>

          <section>
            <h2 className="section-heading--large">
              {t('disclaimer.ownRiskTitle')}
            </h2>
            <p className="text-gray-700">{t('disclaimer.ownRiskDesc')}</p>
          </section>

          <section>
            <h2 className="section-heading--large">
              {t('disclaimer.reportingTitle')}
            </h2>
            <p className="text-gray-700">{t('disclaimer.reportingDesc')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
